<div class="container">

  <mat-card>

    <form [formGroup]="closeGroupForm" (ngSubmit)="submit()">

      <mat-card-content>

        <div fxLayout="column">

          <mat-form-field (click)="closureDatePicker.open()">
            <mat-label>Closed On Date</mat-label>
            <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="closureDatePicker" required formControlName="closureDate">
            <mat-datepicker-toggle matSuffix [for]="closureDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #closureDatePicker></mat-datepicker>
            <mat-error *ngIf="closeGroupForm.controls.closureDate.hasError('required')">
              Closed On Date is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="48%">
            <mat-label>Closure Reason</mat-label>
            <mat-select formControlName="closureReasonId">
              <mat-option *ngFor="let reason of closureData" [value]="reason.id">
                {{ reason.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="closeGroupForm.controls.closureReasonId.hasError('required')">
              Closure Reason is <strong>required</strong>
            </mat-error>
          </mat-form-field>

        </div>

      </mat-card-content>

      <mat-card-actions fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="5px">
        <button type="button" mat-raised-button [routerLink]="['../../']">Cancel</button>
        <button mat-raised-button color="warn" [disabled]="!closeGroupForm.valid">Confirm</button>
      </mat-card-actions>

    </form>

  </mat-card>

</div>
